export default "__VITE_ASSET__DeWxNRO___"